import { useState } from 'react';

export default function StorySection({ story }: { story: string }) {
  const paragraphs = story.split('\n\n').filter((item) => item.trim().length > 0);
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? paragraphs : paragraphs.slice(0, 2);
  const canExpand = paragraphs.length > 2;

  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
      <div className="mb-4 flex items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-100 text-primary-700">
          <i className="ri-book-open-line" aria-hidden="true" />
        </span>
        <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">剧情介绍</h2>
      </div>

      <div className="space-y-4">
        {visible.map((paragraph, index) => (
          <p key={index} className="text-sm leading-7 text-foreground-700 md:text-[15px] md:leading-8">
            {paragraph}
          </p>
        ))}
      </div>

      {canExpand && (
        <button
          type="button"
          onClick={() => setExpanded((prev) => !prev)}
          className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-background-100 px-4 py-2 text-sm font-medium text-primary-600 transition-colors hover:bg-background-200"
        >
          {expanded ? '收起剧情' : '展开完整剧情'}
          <i className={expanded ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} aria-hidden="true" />
        </button>
      )}
    </section>
  );
}